import React from 'react'
import {
  BsFacebook,
  BsGithub,
  BsTwitter,
  BsLinkedin,
  BsArrowUpCircleFill
} from 'react-icons/bs'
import { Container, Row, Col } from 'react-bootstrap'
import './Footer.css'

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <footer className="footer-modern">
      <Container>
        <Row className="align-items-center py-4 g-3">
          <Col xs={12} md={4} className="text-center text-md-start">
            <div className="footer-brand">
              <span className="footer-brand-title">Nithin Dasyam</span>
              <p className="footer-copyright mb-0">
                &copy; {new Date().getFullYear()} Nithin Dasyam. All rights reserved.
              </p>
            </div>
          </Col>

          <Col xs={12} md={4} className="text-center">
            <div className="footer-social-links">
              <a
                href="https://www.linkedin.com/in/nithin-dasyam"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label="LinkedIn profile"
              >
                <BsLinkedin aria-hidden="true" focusable="false" />
              </a>
              <a
                href="https://github.com/nithindasyam"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label="GitHub profile"
              >
                <BsGithub aria-hidden="true" focusable="false" />
              </a>
              <a
                href="https://twitter.com/nithin_dasyam"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label="Twitter profile"
              >
                <BsTwitter aria-hidden="true" focusable="false" />
              </a>
              <a
                href="https://www.facebook.com/nithin.dasyam/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label="Facebook profile"
              >
                <BsFacebook aria-hidden="true" focusable="false" />
              </a>
            </div>
          </Col>

          <Col xs={12} md={4} className="text-center text-md-end">
            <button
              type="button"
              className="back-to-top-btn"
              onClick={scrollToTop}
              aria-label="Back to top"
            >
              <span>Back to top</span>
              <BsArrowUpCircleFill className="ms-2" aria-hidden="true" />
            </button>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer
